/*
 * @Author: Huangxianlong
 * @Date: 2023-08-11 15:34:59
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2026-06-01 14:24:57
 * @FilePath: \monitor\src\language\user\main.js
 * @Description: 
 */
const info = {
  CN: {
    projectOverview: "项目概况",
    realTimeOverview: "实时概况",
    layoutPlan: "平面图",
    latestData: "最新数据",
    realtimeChart: "实时图表",
    report: "报表下载",
    dailtReport: "报表下载",
    projectManagement: "项目管理",
    projectConfiguration: "项目配置",
    zoneConfiguration: "区域配置",
    dataloggerConfiguration: "采集器配置",
    systemManagement: "系统管理",
    userManagement: "用户管理",
    alarmRecord: "报警记录",
    userDetail: "用户信息修改",
    logout: "退出",
    cancelBtn: "取消",
    savelBtn: "保存",
    userFormWarn: "必填信息不能为空",
    userFormSuccess: "修改成功",
    mark: "分区数据概况",
    reportManagement: "报表管理",
    projectOverviewReport: "项目全况报表",
    strainGaugeMonitoringReport: "应变计报表",
    totalStationMonitoringReport: "全站仪报表",
    vm2030MonitoringReport: "振动报表",
    an1001MonitoringReport: "裂缝报表",
    historicalTrendChart: "历史趋势图表",
    gzmConfiguration: "广州地铁配置",
  },
  EN: {
    projectOverview: "Overview",
    realTimeOverview: "Realtime Overview",
    layoutPlan: "Layout Plan",
    latestData: "Latest Data",
    realtimeChart: "Realtime Chart",
    report: "Report",
    dailtReport: "Dailt Report",
    projectManagement: "Project Management",
    projectConfiguration: "Project Configuration",
    zoneConfiguration: "Zone Configuration",
    dataloggerConfiguration: "Datalogger Configuration",
    systemManagement: "System Management",
    userManagement: "User Management",
    alarmRecord: "Alarm Record",
    userDetail: "User Detail",
    logout: "Logout",
    cancelBtn: "Cancel",
    savelBtn: "Save",
    userFormWarn: "Required information cannot be empty",
    userFormSuccess: "Successfully modified",
    mark: "Partition Data Profiling",
    reportManagement: "Report Management",
    projectOverviewReport: "Project Overview Report",
    strainGaugeMonitoringReport: "Strain Gauge Monitoring Report",
    totalStationMonitoringReport: "Prism Monitoring Report",
    vm2030MonitoringReport: "VM2030 Monitoring Report",
    an1001MonitoringReport: "AN1001 Monitoring Report",
    historicalTrendChart: "Historical Trend Chart",
    gzmConfiguration: "GZM Configuration",
  }
};
export default info; //需要暴露出去


// WEBPACK FOOTER //
// ./src/language/user/main.js